import './avatar.scss';

interface IAvatarProps {
	imageUrl?: string;
	initials?: string;
	className?: string;
	style?: React.CSSProperties;
}

const Avatar: React.FC<IAvatarProps> = ({
	imageUrl,
	initials = '',
	className = '',
	style = {}
}) => {
	return (
		<div
			className={`chat-avatar ${className}`}
			style={{ backgroundImage: imageUrl ? `url("${imageUrl}")` : 'none', ...style }}
		>
			{!imageUrl && initials}
		</div>
	);
};

export default Avatar;
